<template>
    <loading-spinner v-if="loading"/>
    <v-row v-else>
        <v-col cols="12" class="title-section">
            {{ $t('common.routines') }}
        </v-col>
        <v-col cols="12" md="6" lg="4" v-for="routine in routines" :key="routine.id">
            <routine-card @click="goToRoutine(routine.id)" :routine="routine" class="ma-0" @hover="onHover(routine.id)" @hover-out="onHoverOut"/>
            <div v-if="isHoverRoutine(routine.id)" class="p-relative">
                <v-card flat class="block-exercises-container kimsa-elevation">
                    <exercise-event
                        v-for="item in routineExercises" :key="item.uid"
                        :event="item" is-hover-view
                    />
                </v-card>
            </div>
        </v-col>
    </v-row>
</template>

<script>
import RoutineCard from "@/components/common/routines/RoutineCard";
import {db} from "@/utils/Firebase";
import LoadingSpinner from "@/components/common/LoadingSpinner";
import ExerciseEvent from "@/components/calendar/ExerciseEvent";

export default {
    name: "ProgramRoutines",
    components: {ExerciseEvent, LoadingSpinner, RoutineCard},
    props: {
        assignedRoutines: {
            type: Array,
            default: null,
        },
        programId: {
            type: String,
            default: '',
        },
        programImg: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            routines: [],
            loading: false,
            hoverRoutine: null,
            blockColors: [],
            blockColorsBase: ['#66CCCC', '#078571', '#99CC00'],
        }
    },
    computed: {
        routineExercises(vm = this) {
            if (vm.hoverRoutine === null || vm.hoverRoutine < 0) return []
            let blocks = vm.assignedRoutines[vm.hoverRoutine].blocks
            let exercises = []
            blocks.forEach((block, i) => {
                let blockColor = vm.getColorBlock(i)
                block.exercises.forEach(exercise => {
                    if (exercise.type === 'exercise') exercises.push({event: {...exercise, color: blockColor}})
                })
            })
            return exercises
        }
    },
    async mounted() {
        const vm = this
        await vm.loadRoutines()
    },
    methods: {
        async loadRoutines() {
            const vm = this
            vm.loading = true

            vm.assignedRoutines.forEach((routine, i) => {
                vm.routines.push({
                    id: i,
                    blocks: routine.blocks,
                    img: vm.programImg,
                    name: `${vm.$t('programs.routine_name')} ${i + 1}`
                })
            })

            vm.loading = false
        },
        goToRoutine(id) {
            const vm = this
            vm.$router.push({name: 'coach.routines.program.detail.routine', params: {uid: vm.programId, id: id}})
        },
        onHover(routineId) {
            const vm = this
            vm.hoverRoutine = routineId
        },
        onHoverOut() {
            const vm = this
            vm.hoverRoutine = null
        },
        isHoverRoutine(routineId) {
            const vm = this
            return vm.hoverRoutine === routineId
        },
        getColorBlock(index) {
            const vm = this
            let blockColor = vm.blockColors[index]
            if (!blockColor) {
                vm.blockColors.push(...vm.blockColorsBase)
                blockColor = vm.blockColors[index]
            }
            vm.blockColors = JSON.parse(JSON.stringify(vm.blockColors))
            return blockColor
        },
    },
}
</script>

<style scoped>

.title-section {
    color: #666666;
    font-size: 17px;
}

.block-exercises-container {
    position: absolute;
    bottom: 78px;
    right: 0;
    border: 1px solid #D9D9D9;
    padding-top: 2px;
    width: 200px;
}

</style>